import { useAtomValue } from 'jotai'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { getDiffKey, type SortItem } from '~/utils'

import { columnsDiffsAtom, countColumnKeysAtom } from '../atoms'
import { useTabulatedColumnCustomerAttributes } from '../hooks/useTabulatedColumnCustomerAttributes'
import {
  getCountColumnLabel,
  getDiffColumnLabel,
  type SortColumnKey,
} from '../utils'

export const useSortButtonItems = () => {
  const columnCustomerAttributes = useTabulatedColumnCustomerAttributes()
  const countColumnKeys = useAtomValue(countColumnKeysAtom)
  const columnsDiffs = useAtomValue(columnsDiffsAtom)
  const { t } = useTranslation()
  const sortButtonItems = React.useMemo<SortItem<SortColumnKey>[]>(
    () => [
      ...countColumnKeys.map((countColumnKey) => ({
        columnKey: countColumnKey,
        label: getCountColumnLabel(columnCustomerAttributes, countColumnKey, t),
      })),
      ...columnsDiffs.map((columnDiff) => ({
        columnKey: getDiffKey(columnDiff),
        label: getDiffColumnLabel(columnCustomerAttributes, columnDiff, t, ''),
      })),
    ],
    [columnCustomerAttributes, columnsDiffs, countColumnKeys, t],
  )

  return sortButtonItems
}
